export const deepCopyArray = (arr: any[]): any[] => {
    return JSON.parse(JSON.stringify(arr));
};
